import dynamic from 'next/dynamic'

export const DynamicVariationsQuickAddModal = dynamic(
  () => import('.').then((mod) => mod.VariationsQuickAddModal),
  { ssr: false },
)
